/**
 * @license Copyright (c) Microsoft Corporation.  All rights reserved.
 */
export var DataSources = {
    EventDataSource: "EventDataSource",
    LegalDataSource: "LegalDataSource",
    CdsDataSource: "CdsProfileDataSource",
    DataverseDataSource: "DataverseDataSource",
    None: "None",
    SegmentMembershipCheckDataSource: "SegmentMembershipCheckDataSource",
    BrandDataSource: "BrandDataSource",
    DataverseSpecificRecordsSource: "DataverseSpecificRecordsDataSource",
    Constant: "ConstantValueDataSource",
    AnonymousSurveySource: "CustomerVoiceAnonymousSurvey",
    NonAnonymousSurveySource: "CustomerVoiceNonAnonymousSurvey",
    ViewEmailInBrowserUrlDataSource: "ViewEmailInBrowserUrlDataSource",
    ConsentDataSource: "ConsentDataSource",
    ContextParentSource: "#parent",
    ContextOutputBase: "#outputs_base",
    ContextOutputBaseRelated: "#outputs_base_related",
    FilterBaseSource: "#filter_base",
    SalesDataSource: "SalesDataSource",
    JourneyDataSource: "JourneyDataSource",
    EventRegistrationFormDataSource: "EventRegistrationFormDataSource"
};
